/*
<summary>
  This functional component is used for proper authentication of user using the Login Credentials (Username & Password)
  Developer:Aashish Singh, Created Date:28-Aug-2022, Last Updated By: Mohammad Saquib Khan, Updated Date: 26-Oct-2022
</summary>
<returns>Returns JSX</returns>
*/

import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { toast } from 'react-toastify';
import Logo from '../../assets/Images/logo.jpg';
import { errorMessage } from '../../constants/error-constants';
import { useStore } from '../../contexts/store-provider';
import ILogin from '../../models/forms/ILogin';
import Footer from '../../shared-components/footer/footer';
import RoutesConstants from '../../shared-components/routes/routes-constants';
import { formatMessage } from '../../translations/format-message';
import LoginForm from './forms/login-form';
import './login.css';
const Login = (props: any) => {
  const { authStore, preferencesStore } = useStore();
  const { error, inProgress, getUserType }: any = authStore;
  const { getVersion } = preferencesStore;
  const { isAuthenticated, getToken, login } = authStore;
  const [cookies, setCookie, removeCookie] = useCookies(['user']);
  const userIdFromCookies = cookies.user;
  const initialValues: ILogin = {
    // Email: emailFromCookies !== undefined ? emailFromCookies : '',
    UserId: userIdFromCookies !== undefined ? userIdFromCookies : '',
    Password: '',
    RememberMe: userIdFromCookies !== undefined ? true : false,
  };

  /**
   * This function handles login functionlity for user
   */
  const handleLogin = (values: ILogin) => {
    if (values.RememberMe === true) {
      setCookie('user', values.UserId);
    } else {
      if (cookies.user !== '') {
        removeCookie('user');
      }
    }
    login(values);
  };

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "isAuthenticated" of the useEffect changed.
   */
  useEffect(() => {
    if (isAuthenticated || getToken) {
      getVersion();
      if (getUserType === 'SuperAdministrator') {
        props.history.push(RoutesConstants.UserManagement);
      } else {
        props.history.push(RoutesConstants.Products);
      }
    }
  }, [isAuthenticated]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "error" of the useEffect changed.
   */
  useEffect(() => {
    if (error) {
      if (error === errorMessage.UserAlreadyLogin) {
        props.confirmLoginPopupToggleHandler();
      } else {
        toast.error(formatMessage(error));
        authStore.reset();
      }
    }
  }, [error]);

  return (
    <>
      <div className="login-outer">
        <div className="login-section">
          <div className="login">
            <img
              src={Logo}
              alt="DID"
              className="logo_img"
            />
            <h3 className="login_title">
              {formatMessage('login_to_your_account')}
            </h3>
            <p className="login_description">{formatMessage('welcome_back')}</p>
            <LoginForm
              isLoading={inProgress}
              loginHandler={handleLogin}
              initialValues={initialValues}
            />
          </div>
        </div>
        <div className="login_wrapper"> </div>
      </div>
      <Footer />
    </>
  );
};

export default observer(Login);
